<template>
    <div class="pb-5">
        <Topnav />

        <div class="container content">
            <div class="my-5">
                <div class="row mb-2 border-bottom border-info">
                    <div class="col-xs-10">
                        <h1 class="p-2">Leader board of {{ bot.first_name }}</h1>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <loading :active.sync="isLoading" :can-cancel="true" color="green"></loading>

                        <div class="container mb-5">
                            <ReferralTable :token="token" :data="subscribers" :show_reset=false v-if="subscribers.length > 0">
                            </ReferralTable>
                        </div>

                    </div>
                </div>

            </div>

        </div>


        <Footer></Footer>
    </div>
</template>
  
  
  
<script>
import Topnav from "@/components/Topnav.vue";
import Footer from "@/components/Footer.vue";


import ReferralTable from "@/components/ReferralTable.vue";

import ApiService from "@/services/ApiService";
import TelegramService from "@/services/TelegramService";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import logo from "@/assets/img/logo-white-text.png";


export default {
    name: "leaderboard",
    components: {
        Topnav,
        Footer,
        Loading,
        ReferralTable,
    },
    props: {
        token: String
    },
    data: function () {
        return {
            user: this.$store.state.user,
            logo: logo,
            isLoading: false,
            bot: {},
            nameError: null,
            subscribers: [],

        };
    },
    methods: {

        getSubscribersRecursive(user, token, lastEvaluatedKey) {
            return new Promise((resolve) => {
                ApiService.getSubscribers(user, token, lastEvaluatedKey)
                    .then(
                        function (result) {
                            this.subscribers = this.subscribers.concat(result.Items);
                            if (result.LastEvaluatedKey) {
                                resolve(this.getSubscribersRecursive(user, token, result.LastEvaluatedKey));
                            }
                            else {
                                resolve(result.Items);
                            }
                        }.bind(this)
                    )
                    .catch(
                        function (response) {
                            this.$dialog.alert(response.description);
                        }.bind(this)
                    );
            });
        },
        getSubscribers(user, token, lastEvaluatedKey) {
            this.isLoading = true;
            ApiService.getSubscribers(user, token, lastEvaluatedKey)
                .then(
                    function (result) {
                        this.subscribers = this.subscribers.concat(result.Items);
                        if (result.LastEvaluatedKey) {
                            this.getSubscribers(user, token, result.LastEvaluatedKey)
                        }
                    }.bind(this)
                )
                .catch(
                    function (response) {
                        this.$dialog.alert(response.description);
                    }.bind(this)
                )
                .finally(
                    function () {
                        this.isLoading = false;
                    }.bind(this)
                );
        },
        showSubscribers() {
            this.subscribers = [];
            this.isLoading = true;
            this.getSubscribersRecursive(this.user, this.token, null)
                .then(
                    function () {
                        this.isLoading = false;
                    }.bind(this)
                )
                .finally(
                    function () {
                        this.isLoading = false;
                    }.bind(this)
                );
        },

        getMe(token) {
            TelegramService.getMe(token)
                .then(
                    function (bot) {
                        this.bot = bot;
                    }.bind(this)
                )
                .catch(
                    function (error) {
                        this.$dialog.alert(error);
                        this.nameError = "Bot name not found";
                    }.bind(this)
                );
        },

        todayDate() {
            var today = new Date();
            var dd = String(today.getDate()).padStart(2, "0");
            var mm = String(today.getMonth() + 1).padStart(2, "0");
            var yy = today.getFullYear();
            today = dd + "-" + mm + "-" + yy.toString().substring(2, 4);
            this.today = today;
        },

    },

    mounted() {
        this.getMe(this.token);
        this.showSubscribers();
    }
};
</script>
  